// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__zbnYj","title":"Card_title__2_plF"};